import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';

@Component({
  selector: 'app-help-copy-and-paste',
  templateUrl: './help-copy-and-paste.component.html'
})
export class HelpCopyAndPasteComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {
    
  }

  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
   
    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.gethelpcopyandpasteLabels();
  }
  cap_header;
  cap_desc;
  cap_para1header;
  cap_para1body;
  gethelpcopyandpasteLabels() {

    this.graphQlService.gethelpcopyandpasteLabels().subscribe(data => {
      if (data != "") {       
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.cap_header = labels.filter(x => x.key == "cop_header").map(y => y.value);
        this.cap_desc = labels.filter(x => x.key == "cop_desc").map(y => y.value);
        this.cap_para1header = labels.filter(x => x.key == "cop_para1heading").map(y => y.value);
        this.cap_para1body = labels.filter(x => x.key == "cop_para1body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }

}
